// RUNN — landing-page enhancement layer.
// Adds (without touching the existing inline UI): PWA service worker, A2HS
// capture, the region-aware cookie banner, and backend waitlist submission.
import { registerSW, setupInstall } from '../pwa/register-sw.js';
import { primeConsentAttributes } from '../compliance/consent.js';
import { initCompliance } from '../compliance/consent-banner.js';
import { joinWaitlist } from '../lib/waitlist.js';

primeConsentAttributes();
registerSW();
setupInstall();

// Cookie/consent banner — the marketing landing is public, so no forced age gate
// here; the neutral 16+ gate guards the app shell where data collection begins.
const cmp = initCompliance({ requireAge: false });
window.__runnOpenPrefs = cmp.openPreferences;

// Backend waitlist submit, layered on top of the existing inline handler.
function wireWaitlist() {
  const jb = document.getElementById('joinBtn');
  const em = document.getElementById('email');
  const cb = document.getElementById('consent');
  if (!jb || !em) return;

  let sent = false;
  const submit = async () => {
    if (sent) return;
    const v = (em.value || '').trim();
    const res = await joinWaitlist(v, cb ? cb.checked : false);
    if (res.ok) sent = true; // the inline handler owns the visible confirmation
    else if (res.reason !== 'invalid-email') console.warn('[RUNN] waitlist submit failed', res);
  };
  jb.addEventListener('click', submit);
  em.addEventListener('keydown', (e) => { if (e.key === 'Enter') submit(); });
}

// Mobile nav: hamburger toggles the dropdown menu (shown ≤980px via CSS).
function wireNav() {
  const burger = document.getElementById('navBurger');
  const nav = document.querySelector('.nav');
  if (!burger || !nav) return;
  const close = () => { nav.classList.remove('open'); burger.setAttribute('aria-expanded', 'false'); };
  burger.addEventListener('click', (e) => {
    e.stopPropagation();
    const open = nav.classList.toggle('open');
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  nav.querySelectorAll('.nav-links a').forEach((a) => a.addEventListener('click', close));
  document.addEventListener('click', (e) => { if (nav.classList.contains('open') && !nav.contains(e.target)) close(); });
  window.addEventListener('resize', () => { if (window.innerWidth > 980) close(); });
}

// Real streets behind the hero turf map (no-key dark basemap, Leaflet + open tiles).
async function mountLandingMap() {
  const el = document.getElementById('mapbg');
  if (!el) return;
  try {
    const { mountBasemap, defaultCenter } = await import('../lib/basemap.js');
    mountBasemap(el, { center: defaultCenter(), zoom: 15, interactive: false });
    document.querySelector('.mapcard')?.classList.add('has-gmap');
    if (window.__runnHeroMap) window.__runnHeroMap.setBackdrop(true);
  } catch (e) {
    console.warn('[RUNN] landing basemap skipped', e);
  }
}

function initLanding() { wireWaitlist(); wireNav(); mountLandingMap(); }

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initLanding, { once: true });
} else {
  initLanding();
}
